export default "__VITE_ASSET__CMd2DghC__"